import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { useQuery } from '@/domains/core/httpClient/queryClient';
import { ABTests } from '../../AddToWishlist/abTests';
import { ID_WISHLIST_ALL_PRODUCTS } from '../../AddToWishlist/constants';
import { allProductsTitle } from '../modules/MainList/MainListCard/translations';
import { useWishlistServices } from './useWishlistServices';
export const useMainCardFetch = (wishlistId?: string | number, enabled = true) => {
  const [isWishlistRevampEnabled] = useBooleanFlags([ABTests.WISHLIST_REVAMP_ENABLED]);
  const {
    calls,
    names
  } = useWishlistServices();
  const {
    data,
    refetch,
    isFetched,
    isLoading
  } = useQuery({
    queryKey: [names.getOne, wishlistId as any],
    queryFn: calls.getOne,
    enabled: wishlistId !== undefined && enabled,
    notifyOnChangeProps: ['data', 'isFetched', 'isLoading'],
    refetchOnWindowFocus: false
  });
  const translatedData = data && wishlistId === ID_WISHLIST_ALL_PRODUCTS ? {
    ...data,
    name: allProductsTitle
  } : data;
  return {
    data: isWishlistRevampEnabled ? translatedData : data,
    refetch,
    isFetched,
    isLoading
  };
};